import React from "react";
import PropTypes from "prop-types";
import "./ConcessionProfileModal.css"; 

const ConcessionProfileModal = ({ show, onHide, concession }) => {
  if (!show || !concession) return null;

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal-overlay') {
      onHide();
    }
  };

  const siren = concession.siret.substring(0, 9);

  React.useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [show]);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>Fiche concession : {concession.nom}</h2>
          <button className="close-button" onClick={onHide}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="form-section">
            <h3 className="profile-section-title">Informations concession</h3>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Nom :</div>
              <div className="profile-info-value">{concession.nom || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">SIRET :</div>
              <div className="profile-info-value">{concession.siret || "Non renseigné"}</div>
            </div>

            <div className="profile-info-row">
              <div className="profile-info-label">SIREN :</div>
              <div className="profile-info-value">{siren || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Email :</div>
              <div className="profile-info-value">{concession.mail || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Téléphone :</div>
              <div className="profile-info-value">{concession.telephone || "Non renseigné"}</div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="profile-section-title">Adresse</h3>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Adresse complète :</div>
              <div className="profile-info-value">
                {concession.numero_voie} {concession.extension} {concession.type_voie} {concession.nom_voie}
              </div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Code postal :</div>
              <div className="profile-info-value">{concession.code_postal || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Ville :</div>
              <div className="profile-info-value">{concession.ville || "Non renseigné"}</div>
            </div>
          </div>

          {concession.espace_note && (
            <div className="form-section">
              <h3 className="profile-section-title">Notes</h3>
              <div className="profile-info-row">
                <div className="profile-info-value note-content">{concession.espace_note}</div>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="button secondary" onClick={onHide}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

ConcessionProfileModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  concession: PropTypes.shape({
    id: PropTypes.number,
    nom: PropTypes.string,
    siret: PropTypes.string,
    siren: PropTypes.string,
    mail: PropTypes.string,
    telephone: PropTypes.string,
    numero_voie: PropTypes.string,
    extension: PropTypes.string,
    type_voie: PropTypes.string,
    nom_voie: PropTypes.string,
    code_postal: PropTypes.string,
    ville: PropTypes.string,
    espace_note: PropTypes.string,
    groupe_id: PropTypes.number
  }),
};

export default ConcessionProfileModal; 